// extracted by mini-css-extract-plugin
export default {"root":"_3R7Q9","warning":"_3MEbO"};